<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc">
<h1 class="SOM_titre" epub:type="title">Contents</h1>
<div class="SOM_pre"><a href="#/pre2">Welcome to Companion Camp</a></div>
<div class="SOM_chap"><span href="#/chap1" title="Link target outside of Sample"><span class="mev1">WEEK ONE</span><br/>
<i>The Four Kinds of Love</i></span></div>
<div class="SOM_chap"><span href="#/chap2" title="Link target outside of Sample"><span class="mev1">WEEK TWO</span><br/>
<i>Growing Quiet Before You Grow Closer</i></span></div>
<div class="SOM_chap"><span href="#/chap3" title="Link target outside of Sample"><span class="mev1">WEEK THREE</span><br/>
<i>Growing Strong by Growing Wiser</i></span></div>
<div class="SOM_chap"><span href="#/chap4" title="Link target outside of Sample"><span class="mev1">WEEK FOUR</span><br/>
<i>Growing Old with Your Fragility Primed</i></span></div>
<div class="SOM_chap"><span href="#/chap5" title="Link target outside of Sample"><span class="mev1">WEEK FIVE</span><br/>
<i>Who Loved You into Being?</i></span></div> <div class="SOM_appen"><span href="#/appen3" title="Link target outside of Sample">Also Available</span></div>
<div class="SOM_appen"><span href="#/appen4" title="Link target outside of Sample">About the Author</span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?2178a29c